import React, {useEffect, useRef} from 'react';
import { StyledVideoScroll } from './StyledVideoScroll';
import { gsap } from "gsap";

import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const VideoScroll = ({ video, poster, idScroll, align , noAnimation}) => {
  const videoHolderRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    
    var videoEl = videoRef.current.querySelector('video');
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    videoRef.current.muted="muted"
    videoRef.current.defaultMuted = true;

    if(noAnimation) {
      ScrollTrigger.create({
        trigger: videoHolderRef.current,
        start: 'top center',
        end: 'bottom top',
        id: idScroll,
        scrub: 0.1,
        onEnter: () => {
          videoEl.play()
        },
        onEnterBack: () => {
          videoEl.play()
        },
        onLeave: () => {
          videoEl.pause()
        },
        onLeaveBack: () => {
          videoEl.pause()
        }
      })
    }else{
      ScrollTrigger.create({
        trigger: videoHolderRef.current,
        start: 'top center',
        end: 'bottom top',
        id: idScroll,
        scrub: 0.1,
        onEnter: () => {
          
          gsap.to(videoRef.current, {width: "100%", left: 0, right: 0, margin: 0, padding: 0, onComplete: () =>{
  
            videoEl.play()
          }})
        },
        onLeave: () => {
          var leaveWidth = '83.3%';
          var leaveLeft =  window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leaveRight = window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leavePaddingRight = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leavePaddingLeft = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leaveMarginLeft = "8.33%" 
          var leaveMarginRight = "8.33%"
          var leaveBottom = window.innerWidth <= 768 ? -80 : window.innerWidth <= 1023 ? -128 : -160;
          
  
          if(align !== 'right')
            gsap.to(videoRef.current,
              {width: leaveWidth, bottom: leaveBottom, marginLeft: leaveMarginLeft, left: leaveLeft, paddingRight: leavePaddingRight, 
                onComplete: () =>{
                videoEl.pause()
              }
            })
          else 
            gsap.to(videoRef.current,
              {width: leaveWidth, bottom: leaveBottom, marginRight: leaveMarginRight, right: leaveRight, paddingLeft: leavePaddingLeft, 
                onComplete: () =>{
                videoEl.pause()
              }
            })
        },
        onEnterBack: () => {
          gsap.to(videoRef.current, {width: "100%", left: 0,  right: 0, margin: 0, padding: 0, onComplete: () =>{
            videoEl.play()
          }})
        },
        onLeaveBack: () => {
  
          var leaveWidth = '83.3%';
          var leaveLeft =  window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leaveRight = window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leavePaddingRight = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leavePaddingLeft = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leaveMarginLeft = "8.33%" 
          var leaveMarginRight = "8.33%"
          var leaveBottom = window.innerWidth <= 768 ? -80 : window.innerWidth <= 1023 ? -128 : -160;
          
  
          gsap.to(videoRef.current,
            {width: leaveWidth, bottom: leaveBottom, marginRight: leaveMarginRight, right: leaveRight,marginLeft: leaveMarginLeft, left: leaveLeft, paddingRight: leavePaddingRight, 
              onComplete: () =>{
              videoEl.pause()
            }
          })
        }
      })
    }

    
    return () => {
      ScrollTrigger.getById(idScroll).kill();
    }
  }, [])

  return (
    <React.Fragment>
      {
       
          <StyledVideoScroll
          ref={videoHolderRef}
          className={align}
          noAnimation={noAnimation}
          >
            <div className="video--wrap" ref={videoRef}>
              <video loop muted={true} playsInline preload="metadata" controls>
                <source src={video} type="video/mp4"></source>
              </video>
            </div>            
          </StyledVideoScroll>
          
      }
    </React.Fragment>
  );
};

export default VideoScroll;
